import { defineStore } from "pinia";
import { useApi } from "~~/lib";
import type { IMenuData } from "~~/types/menu";
import type { IMainLocation } from "~~/types/region";
import { useCartStore } from "./cartStore";
import { useFavoriteStore } from "./favoriteState";
import { useRegionStore } from "./regionStore";
import { useUserStore } from "./userStore";
import { useFlashStore } from "./flashStore";
import type { IApiPingResponse } from "~/types/api";
import { useMenuStore } from "./menuState";

export const useMainStore = defineStore('main', () => {

    const favoriteStore = useFavoriteStore();
    const cartStore = useCartStore();
    const userStore = useUserStore();

    const location: Ref<null | IMainLocation> = ref(null);
    const mainMenu: Ref<null | IMenuData> = ref(null);
    const ordersCount = ref(0);
    const shouldAskGeo = ref(false);

    const api = useApi();

    async function tryInit() {
        if (!location.value) {
            return init();
        }
    }

    async function init() {

        const data = await api.request('/rest/v2/init');

        if (location.value && data.user && !userStore.user) {
            useFlashStore().setFlash('Успешная авторизация', 'success', 5000);
        }

        userStore.setUser(data.user);

        if (location.value) {
            Object.assign(location.value, data.location);
        } else {
            location.value = data.location;
        }

        mainMenu.value = data.menu;

        ordersCount.value = data.orders;

        favoriteStore.count = data.favorites;

        shouldAskGeo.value = data.askGeo;

        cartStore.setCartData(data.cart, false);
        useMenuStore().headerMenu = data.menu;
    }

    let loading = false;

    async function ping() {
        if (loading) {
            return;
        }

        loading = true;

        try {
            const response = await api.request<IApiPingResponse>('/rest/v2/ping');

            if (!response || response.l[2] !== location.value?.city.content) {
                return init();
            }

            if (response.l[0] !== location.value.city.id) {
                location.value.city.id = response.l[0];
                location.value.city.name = response.l[1];
            }

            ordersCount.value = response.o;
            favoriteStore.count = response.f;

            cartStore.checkKey(response.c);
        } finally {
            loading = false;
        }
    }

    async function login(login: string, password: string) {
        const data = await api.request('/rest/user/login', {
            login, password
        });

        init();
    }
    async function logout() {

        const data = await api.request('/rest/user/logout');

        init();
    }

    async function loginByPhone(phone: string, code: string) {
        const data = await api.request('/rest/auth/use-phone-code', {
            phone, code
        });

        init();
    }

    return {location, shouldAskGeo, init, ping, login, logout, loginByPhone, tryInit, mainMenu, ordersCount};
});
